import RoutingComponent from './RoutingComponent';

export default RoutingComponent;
